import React, { useState, useEffect } from "react";
import styles from "./LoadPayoutMasterAccountPage.module.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
export default function LoadPayoutMasterAccountPage({ selectedCompany, selectedAccount, apiService, onSubmit }) {
  const [payout_master_access, setPayoutMasterAccess] = useState('false')
  const [payoutAccount, setPayoutAccount] = useState({});
  const [previousLoads, setPreviousLoads] = useState([]);
  const [amount, setAmount] = useState("");
  const [confirmAmount, setConfirmAmount] = useState("");
  const [open, setOpen] = useState(false);
  const [lastLoad, setLastLoad] = useState(null);
  const [numericAmount, setNumericAmount] = useState(0);
  const [amountsMatch, setAmountsMatch] = useState(false);
  const [positive, setPositive] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [withinBalance, setWithinBalance] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [adjustment_ref, setAdjustmentRef] = useState('');
  const [is_confirm_disabled, setIsConfirmDisabled] = useState(false)
  const [is_payout_enabled, setIsPayoutEnabled] = useState(false);
  const [is_view_authroized, setIsViewAuthorized] = useState(false)
  const [is_load_authorized, setIsLoadAuthroized] = useState(false)
  const [is_loading,setIsLoading] = useState(false)
  const defaultPayoutAccount = {
    id: "PA-001",
    name: "Main Payout Master",
    balance: 3_200_000,
  };

  const defaultPreviousLoads = [
    {
      id: "LD-00027",
      amount: 750_000,
      timestamp: Date.now() - 1 * 3600 * 1000,
    },
    {
      id: "LD-00026",
      amount: 600_000,
      timestamp: Date.now() - 24 * 3600 * 1000,
    },
    {
      id: "LD-00025",
      amount: 550_000,
      timestamp: Date.now() - 48 * 3600 * 1000,
    },
    {
      id: "LD-00024",
      amount: 800_000,
      timestamp: Date.now() - 72 * 3600 * 1000,
    },
    {
      id: "LD-00023",
      amount: 500_000,
      timestamp: Date.now() - 96 * 3600 * 1000,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        // API call to fetch payout account
        // var user_profile = localStorage.getItem("user_profile");
        // if (!user_profile) {
        //   var response = await apiService({
        //     method: "post",
        //     path: "/user/get_user_profile",
        //     payload: {},
        //   });
        //   var user_profile = response.data;
        //   localStorage.setItem("user_profile", JSON.stringify(user_profile));
        //   setUserProfile(localStorage.getItem("user_profile"));
        // } else {
        //   user_profile = JSON.parse(user_profile);
        // }
        // setPreviousDebits( defaultPreviousDebits);
        setIsLoading(true)
        var response = await apiService({
          method: "post",
          path: "/user/get_account_details",
          payload: { company: selectedCompany, account: selectedAccount },
        });
        setIsPayoutEnabled(response.data.is_payout_enabled);
        var response = await apiService({ method: "post", path: "/user/load_payout_master", payload: { company: selectedCompany, account: selectedAccount } });
        setIsViewAuthorized(response.data.is_view_authorized)
        setIsLoadAuthroized(response.data.is_load_authroized)
        setIsLoading(false)
        if (response.data.load_payout_master && response.data.load_payout_master == 'false') {
          var latest_adjustments = response.data.latest_adjustments;
          setPreviousLoads(latest_adjustments);
          setPayoutAccount({})
          setPayoutMasterAccess('false')
          return;
        }
        var payoutMasterAccount = response.data.sub_account_balances[0];
        setPayoutAccount(payoutMasterAccount);
        // API call to fetch previous loads
        var latest_adjustments = response.data.latest_adjustments;
        setPreviousLoads(latest_adjustments);
        setPayoutMasterAccess('true')
      } catch (error) {
        console.error("API fetch failed, using default values:", error);
        setPayoutAccount({});
        setPreviousLoads([]);
      }
    };

    fetchData();
  }, [selectedCompany, selectedAccount]);

  useEffect(() => {
    // Set last load
    setLastLoad(previousLoads[0] ?? null);

    // Calculate numeric amount
    const newNumericAmount = parseFloat(amount) || 0;
    setNumericAmount(newNumericAmount);

    // Check if amounts match
    setAmountsMatch(amount !== "" && amount === confirmAmount);

    // Check if amount is positive
    setPositive(newNumericAmount > 0);

    // Check for duplicate
    setDuplicate(lastLoad && newNumericAmount === lastLoad.amount);

    // Check if within balance
    setWithinBalance(newNumericAmount <= payoutAccount.balance);

    // Validate
    setIsValid(
      newNumericAmount > 0 &&
      amount !== "" &&
      amount === confirmAmount
    );
  }, [amount, confirmAmount, previousLoads, payoutAccount.balance]);

  const handleAttemptSubmit = () => {
    var adustment_ref = moment().format('YYYYMMDDHHmmss') + '-Main-Account-Load'
    if (!isValid) return;
    setAdjustmentRef(adustment_ref)
    if (!isValid) return;
    setOpen(true);
  };

  const handleConfirm = async () => {
    const payload = { payoutAccountId: payoutAccount.id, amount: numericAmount };
    setIsConfirmDisabled(true)
    try {
      // API call to submit load request
      // const response = await fetch("/api/submitLoad", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(payload),
      // });

      // if (!response.ok) throw new Error("Failed to submit load request");

      var response = await apiService({ method: "post", path: "/user/load_to_payout_master", payload: { company: selectedCompany, account: selectedAccount, adjustment_ref, load_amount: numericAmount } });
      // Call onSubmit prop if provided
      onSubmit?.(payload);
      var newLoadAccountBalance = response.data.credit_account_balance;
      setPayoutAccount(newLoadAccountBalance)
      setPreviousLoads(response.data.latest_adjustments)
      // Reset form and close dialog
      setAmount("");
      setConfirmAmount("");
      setOpen(false);
      setIsConfirmDisabled(false)
    } catch (error) {
      console.error("Submit API call failed:", error);
      // Optionally, you could show an error message to the user here
    }
  };

   const columns = [{
    name: "adjustment_ref",
    label: "Adjustment Ref",
    options: {
      filter: true,
      sort: true,
    }
  }, {
    name: "amount",
    label: "Amount (₹)",
    options: {
      filter: true,
      sort: true,
    }
  }, {
    name: "timestamp",
    label: "Time & Date",
    options: {
      filter: true,
      sort: true,
    }
  }
  ];


  const options = {
    selectableRows: false,
    selectableRowsHideCheckboxes:"false"
  };

  return (
    <div className={styles.container}>

      {(is_payout_enabled == true || payout_master_access == 'true') && is_view_authroized && (
        <div className={styles.card}>

          {/* <div className={styles.cardHeader}>{payout_master_access == 'true' ? 'Load Payout Master Account' : 'Loads'}</div> */}

          <div className={styles.cardContent}>
            <div className={styles.section}>
              {/* <p className={styles.sectionTitle}>Last 5 Loads</p> */}
               <MUIDataTable
                              title={"Latest Loads"}
                              data={previousLoads}
                              columns={columns}
                              options={options}
                            />
              {/* {previousLoads.length ? (
                <table className={styles.table}>
                  <thead>
                    <tr className={styles.tableHeaderRow}>
                      <td className={styles.tableheading1}>Adjustment Ref</td>
                      <td className={styles.tableheading}>Amount (₹)</td>
                      <td className={styles.tableheading}>Time & Date</td>
                    </tr>
                  </thead>
                  <tbody>
                    {previousLoads.slice(0, 5).map((l) => (
                      <tr key={l.id}>
                        <td>{l.adjustment_ref}</td>
                        <td style={{ textAlign: "right" }}>
                          {l.amount.toLocaleString("en-IN")}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {new Date(l.timestamp).toLocaleString("en-IN", {
                            hour12: false,
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className={styles.noData}>No previous loads</p>
              )} */}
            </div>

            {payout_master_access == 'true' && (
              <div className={styles.balanceSection}>
                <span className={styles.balanceLabel}>Current Balance</span>
                <span className={styles.balanceAmount}>
                  ₹{payoutAccount.balance?.toLocaleString("en-IN") ?? "0"}
                </span>
              </div>
            )}
            {payout_master_access == 'true' && is_load_authorized && (
              <div className={styles.inputSection}>
                <div className={styles.inputGroup}>
                  <label htmlFor="loadAmt" className={styles.label}>
                    Load Amount
                  </label>
                  <input
                    id="loadAmt"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Enter amount (₹)"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <div className={styles.inputGroup}>
                  <label htmlFor="confirmAmt" className={styles.label}>
                    Re-enter Load Amount
                  </label>
                  <input
                    id="confirmAmt"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Re-enter amount (₹)"
                    value={confirmAmount}
                    onChange={(e) => setConfirmAmount(e.target.value)}
                  />
                </div>

                {!amountsMatch && confirmAmount !== "" && (
                  <div className={styles.error}>
                    <svg
                      className={styles.errorIcon}
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                    Amounts do not match.
                  </div>
                )}
                {duplicate && (
                  <div className={styles.error}>
                    <svg
                      className={styles.errorIcon}
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                    Duplicate of the last successful load.
                  </div>
                )}
                {/* {!withinBalance && numericAmount > 0 && (
              <div className={styles.error}>
                <svg
                  className={styles.errorIcon}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                Amount cannot exceed current balance (₹
                {payoutAccount.balance?.toLocaleString("en-IN") ?? "0"}).
              </div>
            )} */}
              </div>
            )}
          </div>

          {payout_master_access == 'true' && is_load_authorized && (
            <div className={styles.cardFooter}>
              <button disabled={!isValid} onClick={handleAttemptSubmit}>
                Submit Load
              </button>
            </div>
          )}

          {payout_master_access == 'true' && is_load_authorized == false && (
            <div className={styles.cardFooter}>
              <div> No Authroized to Load Funds To Master Load account</div>
            </div>
          )}
          {payout_master_access == 'true' && open && (
            <div className={styles.dialogContent}>
              <div>
                <div className={styles.heading}>Confirm Load</div>
              </div>
              <p className={styles.dialogText}>
                You are about to load{" "}
                <span className={styles.head33}>
                  ₹{numericAmount.toLocaleString("en-IN")}
                </span>{" "}
                into the {selectedCompany}'s {selectedAccount}
              </p>
              <div className={styles.dialogFooter}>
                <button onClick={() => setOpen(false)}>Cancel</button>
                <button disabled={is_confirm_disabled} onClick={handleConfirm}>{is_confirm_disabled ? 'Processing....' : 'Confirm'}</button>
              </div>
            </div>
          )}
        </div>
      )}
      {is_view_authroized && is_payout_enabled == false && payout_master_access == 'false' && (
        <div className={styles.card}>
          <div className={styles.cardHeader}>Payout Not Enabled for this Account</div>
        </div>
      )}

      {is_view_authroized == false && is_loading==false && (
        <div className={styles.card}>
          <div className={styles.cardHeader}>Not Authroized</div>
        </div>
      )}
      {is_loading && (
        <div className={styles.card}>
        <div className={styles.cardHeader}> is Loading</div>
      </div>
      )}
    </div>
  );
}